import styles from "./SimpleSlider.module.css";

export function SimpleSlider({
  min,
  max,
  step,
  value,
  setValue,
}: {
  min: number;
  max: number;
  step: number;
  value: number;
  setValue: (value: number) => void;
}) {
  const denominator = max - min;
  // When max is not on a step boundary, extend the input's max up to the next
  // step so the user can drag the thumb past the last full step and reach the
  // real max. Emitted values are clamped back to max in onChange.
  const inputMax = step > 0 && denominator > 0 ? min + Math.ceil(denominator / step) * step : max;
  const fillPercentage =
    denominator === 0 ? 100 : Math.min(((value - min) / denominator) * 100, 100);

  return (
    <div className={styles.sliderContainer}>
      <div className={styles.rangeTrackBackground} />
      <div
        className={styles.rangeTrackFill}
        style={{
          width: `${fillPercentage}%`,
        }}
      />
      <input
        type="range"
        min={min}
        max={inputMax}
        step={step}
        value={value}
        className={styles.rangeSlider}
        onChange={(e) => setValue(Math.min(Number(e.target.value), max))}
      />
    </div>
  );
}
